import { Grid, Pagination } from "@mui/material";

function SupplyTablePaging({page, maxPage, changePage}) {

  return (
    <Grid container>
      <Grid item xs={12} textAlign="center">
        <Pagination
          count={maxPage}
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={(_, page) => changePage(page)}
          defaultPage={1}
          sx={{ mt: 1, display: "inline-block" }}
        />
      </Grid>
    </Grid>
  );
}

export default SupplyTablePaging;